import * as moment from 'moment';
import {StateParams} from 'angular-ui-router';

import {IStationApi} from '../../../api/station-api.service';
import {IDataValueApi} from '../../../api/data-value-api.service';
import {IStation, IPrecipitationNorm, ITemperatureNorm} from '../../../api/api.types';
import {IS3UploadService} from '../../../utils/s3-upload.service';
import {IMeteostationHistoricNormEvents} from '../historic-norm.controller';

export interface IStationHistoricNormStateParams extends StateParams {
  stationId: string;
}

export default class StationMeteoDataTableController {
  static $inject = ['stationApi', 'dataValueApi', 's3UploadService', '$q', '$stateParams', '$scope'];

  station:IStation;
  normRows:Array<{
    month:string,
    data:Array<number>
  }>;
  normStartYear:number;
  normEndYear:number;
  type: string;

  isLoading:boolean;
  isHistoricalDataLoading:boolean;
  normPromise:ng.IPromise<void>;

  constructor(private stationApi:IStationApi,
              private dataValueApi: IDataValueApi,
              private s3UploadService:IS3UploadService,
              private $q:ng.IQService,
              private $stateParams:IStationHistoricNormStateParams,
              private $scope:ng.IScope) {
    this.normRows = [];
    const months = moment.months();
    for (let i = 0; i < 12; ++i) {
      this.normRows.push({
        month: months[i],
        data: [undefined, undefined, undefined]
      });
    }
    this.$scope.$on(IMeteostationHistoricNormEvents.NEW_DATA_UPLOADED, () => {
      this.loadData();
    });
    this.loadData();
  }

  private loadData(){
    const stationId = Number.parseInt(this.$stateParams.stationId);
    this.loadNorm(stationId);
  }

  private loadNorm(stationId:number) {
    this.clearNormRows();
    this.normPromise = this.dataValueApi.getStationNorm(stationId, this.type)
        .then(stationNorm => {
          this.normStartYear = stationNorm.startYear;
          this.normEndYear = stationNorm.endYear;
          this.processNorm(stationNorm);
        });
  }

  private clearNormRows() {
    this.normRows.forEach((row) => {
      row.data = [undefined, undefined, undefined];
    });
  }

  private processNorm(stationNorm:IPrecipitationNorm | ITemperatureNorm) { 
    let currentRow:{
      month:string,
      data:Array<number>
    };
    for (let i = 0; i < stationNorm.normData.length; ++i) {
      if (i % 3 == 0) {
        currentRow = this.normRows[Math.floor(i / 3)];
      }
      currentRow.data[i % 3] = stationNorm.normData[i];
    }
  }
}



/** WEBPACK FOOTER **
 ** ./app/meteostation/historic-norm/meteoDataTable/meteo-data-table.controller.ts
 **/